import { render, staticRenderFns } from "./WordpressPublishModal.vue?vue&type=template&id=ea40eeda&"
import script from "./WordpressPublishModal.vue?vue&type=script&lang=js&"
export * from "./WordpressPublishModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WordpressPublishModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/WordpressPublishModal.vue
// module id = 1700
// module chunks = 1